import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolGroupsStore } from './symbolGroups.interface';

export const symbolGroupsInitialState: ISymbolGroupsStore = {
  symbolGroups: [],
  networkStatus: NetworkStatus.None,
};
